<template>
	<div class="plate_text cursor-pointer d-flex flex-column justify-content-center" :class="{ highlighted: selected }" @click="$emit('click', plate_code)" :style="getPercentStyle(pct)">
		<div class="d-flex justify-content-between align-items-center no-wrap">
			<span class="plate-name text-truncate mr-1">{{plate_name}}</span>
			<span class="plate-value font-weight-bold ml-auto" v-if="c_num">{{c_num}}</span>
		</div>
		<div v-if="is_show_row2" class="plate-row2 d-flex justify-content-between align-items-center no-wrap">
			<span class="money-val">{{num1}}</span>
			<span class="money-diff" :style="{ color: num2 > 0 ? '#ff3333' : '#00e400' }">
				({{ num2 > 0 ? '+' + num2 : num2 }})
			</span>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			plate_code: String,
			plate_name: String,
			pct: Number,
			c_num: [Number, String],
			selected: Boolean,
			num1: [Number, String],
			num2: [Number, String],
			is_show_row2: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {

			};
		},
		computed: {

		},
		methods: {
			getPercentStyle(pt) {
                const val = parseFloat(pt);
                if (isNaN(val) || val === 0) return {};

                const color = val > 0 ? '251, 16, 35' : '39, 139, 34'; // #FB1023 or #278B22
                const opacity = Math.min(Math.abs(val) / 10, 0.6);
                
				return {
					'--pt-overlay': `rgba(${color}, ${opacity})`
				}
			},
		}

	}
</script>

<style scoped>
	.plate_text {
		border: 1px solid var(--border-color, lightgray);
		color: var(--text-main, #333);
        border-radius: 4px;
        padding: 2px 6px;
        transition: all 0.2s;
        background-color: var(--bg-card, #fff);
        position: relative;
        z-index: 1;
		white-space: nowrap;
		overflow: hidden;
		min-height: 32px;
	}

	.no-wrap {
		white-space: nowrap;
	}

	.plate-name {
		font-size: 0.85rem;
		font-weight: 500;
	}

	.plate-value {
		font-size: 0.75rem;
		opacity: 0.8;
	}

	.plate-row2 {
		font-size: 0.75rem;
		margin-top: 2px;
		border-top: 1px solid rgba(0,0,0,0.05);
		padding-top: 2px;
	}

	body.theme-dark .plate-row2 {
		border-top-color: rgba(255,255,255,0.05);
	}

    .plate_text::before {
        content: "";
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        background-color: var(--pt-overlay, transparent);
        z-index: -1;
        border-radius: 3px;
    }

	.highlighted {
		background-color: var(--accent-color, gold) !important;
		color: #fff !important;
		border: 2px solid var(--color-up-color, red);
        box-shadow: 0 0 8px var(--accent-color);
	}
</style>
